import React, { useState } from "react";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import '../../parking.scss';

const MacrosModal = ({ macros, isOpen, toggle }) => {
    const [selectedLayoutIndex, setSelectedLayoutIndex] = useState(0);

    if (!macros) return null;

    const layouts = macros.layouts_based_on_property_id;
    const selectedLayout = layouts[selectedLayoutIndex];

    return (
        <Modal isOpen={isOpen} toggle={toggle} size="lg" className="macros-modal">
            <ModalHeader toggle={toggle}>
                <span className="text-white">Parking Macros</span>
            </ModalHeader>  
            <ModalBody>
                {/* Layout tab switcher */}
                <div className="layout-tabs">
                    {layouts.map((layout, index) => (
                        <button
                            key={index}
                            className={`layout-tab-btn ${selectedLayoutIndex === index ? 'active' : ''}`}
                            onClick={() => setSelectedLayoutIndex(index)}
                        >
                            {layout.layout}
                        </button>
                    ))}
                </div>

                {/* Summary stats */}
                <div className="d-flex gap-3 mb-3">
                    {[
                        { label: 'Total', value: selectedLayout.total_slots, color: '#4361ee' },
                        { label: 'Assigned', value: selectedLayout.allotted_slots, color: '#f5a623' },
                        { label: 'Vacant', value: selectedLayout.available_slots, color: '#2cb67d' },
                    ].map(({ label, value, color }) => (
                        <div
                            key={label}
                            style={{
                                flex: 1, textAlign: 'center', padding: '10px 0',
                                borderRadius: 8, border: `1px solid ${color}22`,
                                background: `${color}11`,
                            }}
                        >
                            <div style={{ fontSize: '1.4rem', fontWeight: 700, color }}>{value}</div>
                            <div style={{ fontSize: '0.75rem', color: '#8492a6', fontWeight: 600, textTransform: 'uppercase' }}>{label}</div>
                        </div>
                    ))}
                </div>

                {/* Detail table */}
                <div className="macros-table table-responsive">
                    <table className="table mb-0">
                        <thead>
                            <tr>
                                <th>Parking Info</th>
                                <th>Details</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Occupied Slots</td>
                                <td>
                                    {Object.entries(selectedLayout.occupied_slots).length > 0 ? (
                                        Object.entries(selectedLayout.occupied_slots).map(([type, slots], idx) => (
                                            <div key={idx} className="mb-1">
                                                <span className="text-muted me-1" style={{ fontSize: '0.78rem' }}>{type}:</span>
                                                <div className="slot-list mt-1">
                                                    {slots.map((s, i) => (
                                                        <span key={i} className="slot-chip">{s}</span>
                                                    ))}
                                                </div>
                                            </div>
                                        ))
                                    ) : (
                                        <span className="text-muted">None</span>
                                    )}
                                </td>
                            </tr>
                            <tr>
                                <td>Vacant Slots</td>
                                <td>
                                    {Object.entries(selectedLayout.vacant_slots).length > 0 ? (
                                        Object.entries(selectedLayout.vacant_slots).map(([type, slots], idx) => (
                                            <div key={idx}>
                                                <div className="slot-list">
                                                    {slots.map((s, i) => (
                                                        <span key={i} className="slot-chip" style={{ background: '#e8f8f1', color: '#2cb67d' }}>{s}</span>
                                                    ))}
                                                </div>
                                            </div>
                                        ))
                                    ) : (
                                        <span className="text-muted">None</span>
                                    )}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </ModalBody>
        </Modal>
    );
};

export { MacrosModal };